import widgetService from 'live/services/widgets'
import PositionsReport from './PositionsReport'
import { reducer } from './reducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { ChartMessage, ChartState } from './types'
import Config from './config'
import { DEFAULT_CHART_CONFIG } from './constants'

export default widgetService.register({
    type: 'positions-report',
    get name() {
        return 'Positions Report'
    },
    get description() {
        return 'Positions Report'
    },
    config: DEFAULT_CHART_CONFIG,
    ui: {
        configForm: Config
    },

    impl: reactWidgetWrapper<ChartState, ChartMessage>(PositionsReport, reducer)
})
